import * as React from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Box } from "@mui/material";
import UserAvatar from "./user-avatar";
import { useAuth } from "../auth/identity-auth0-context";
import LoginButton from "./login-button";

const Account = () => {
  const { user, isAuthenticated, signoutRedirect, signinRedirect } = useAuth();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleCloseMenu();
    signoutRedirect?.();
  };

  const handleLogin = () => {
    handleCloseMenu();
    signinRedirect?.();
  };

  const menuOpen = Boolean(anchorEl);

  return (
    <Box>
      {isAuthenticated ? (
        <UserAvatar userName={user?.name ?? "?"} onClick={handleOpen} />
      ) : (
        <LoginButton onClick={handleLogin} />
      )}
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleCloseMenu}
        slotProps={{
          list: {
            "aria-labelledby": "account-button",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, lineHeight: 1.2 }}
          >
            {user?.name ?? "User"}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "0.8rem" }}
          >
            {user?.email}
          </Typography>
        </Box>
        <Divider />

        <MenuItem onClick={handleLogout} aria-label="account-logout">
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="subtitle2">Sign out</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default Account;
